import React from 'react';
import { NSCard } from 'bricks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo, faWarning } from '@fortawesome/free-solid-svg-icons';
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';
import RenderIf from 'components/RenderIf/RenderIf';

export interface INSInfoBannerProps {
    title: string;
    highlightTitle?: string | React.ReactNode;
    subtitle?: string | React.ReactNode;
    className?: string;
    warning?: boolean;
    customInfo?: React.ReactNode;
    showIcon?: boolean;
    carouselNavigator?: React.ReactNode;
    boldTitle?: boolean;
    customIcon?: IconProp;
    iconSize?: SizeProp;
}

export const NSInfoBanner = ({
    title, subtitle = '', highlightTitle = '', className = '', warning = false, customInfo = undefined,
    showIcon = true, carouselNavigator, boldTitle = true, customIcon, iconSize = 'lg',
}: INSInfoBannerProps) => {
    const icon = customIcon || (warning ? faWarning : faInfo);
    const iconClassName = `icon mx-1${warning ? ' text-warning' : ''}`;

    return (
        <NSCard className={`${className} p-2 shadow-none`}>
            <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                    {showIcon && <FontAwesomeIcon className={iconClassName} icon={icon} fixedWidth size={iconSize} />}
                    <div className="ml-1">
                        {carouselNavigator}
                        <RenderIf isTrue={highlightTitle}>
                            <div className="text-uppercase text-primary font-14">
                                {highlightTitle}
                            </div>
                        </RenderIf>
                        <div className={`mb-0 text-dark font-14 ${boldTitle ? 'font-weight-bold' : ''}`}>{title}</div>
                        <div className="text-muted font-14">{subtitle}</div>
                    </div>
                </div>
                <RenderIf isTrue={customInfo}>
                    <div className="align-items-center">{customInfo}</div>
                </RenderIf>
            </div>
        </NSCard>
    );
};

export default NSInfoBanner;
